import React from 'react';
import { Section } from './Section';
import { Zap, Shield, Lock } from 'lucide-react';
import { motion } from 'framer-motion';
const pillars = [{
  icon: Zap,
  title: 'Proven Technology',
  desc: 'Advanced neural network refined for real-world acoustic environments.'
}, {
  icon: Shield,
  title: 'Enterprise-Grade Reliability',
  desc: 'Remote management and automatic recovery, always operational.'
}, {
  icon: Lock,
  title: 'Data Privacy Compliance',
  desc: "Audio stays local. Your clients' privacy is strictly protected."
}];
export function Trust() {
  return <Section id="trust" className="bg-zinc-50 border-y border-zinc-200 overflow-hidden" data-id="element-241">
      <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-242">
        <div data-id="element-243">
          <span className="text-peoplecall tracking-wider text-sm font-semibold mb-4 block" data-id="element-244">
            Why Peoplecall
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 leading-tight text-zinc-900" data-id="element-245">
            The intelligence of AI.
            <br data-id="element-246" />
            The solidity of Peoplecall.
          </h2>
          <p className="text-lg text-zinc-600 mb-10 leading-relaxed" data-id="element-247">
            Peoplecall Pod is not just a detection device — it's a managed
            security service backed by Peoplecall's expertise and
            infrastructure. Our teams monitor, update, and maintain every unit
            remotely, ensuring your system is always current, always
            operational.
          </p>

          <div className="space-y-8" data-id="element-248">
            {pillars.map((pillar, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2
          }} className="flex gap-4" data-id="element-249">
                <div className="mt-1 w-10 h-10 rounded-lg bg-peoplecall/10 flex items-center justify-center flex-shrink-0" data-id="element-250">
                  <pillar.icon className="w-5 h-5 text-peoplecall" data-id="element-251" />
                </div>
                <div data-id="element-252">
                  <h4 className="text-xl font-bold text-zinc-900 mb-2" data-id="element-253">
                    {pillar.title}
                  </h4>
                  <p className="text-zinc-600" data-id="element-254">{pillar.desc}</p>
                </div>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="relative h-full min-h-[420px] rounded-2xl overflow-hidden border border-zinc-200 shadow-lg" data-id="element-255">
          <img src="https://cdn.magicpatterns.com/uploads/s6ThsYBDs8Gq3Suh9bsnam/listen-in.png" alt="Peoplecall alarm monitoring center operator listening in" className="absolute inset-0 w-full h-full object-cover" data-id="element-256" />
        </motion.div>
      </div>
    </Section>;
}